var SearchByMoto = (function ($) {

    var removeSelectBoxesContent = function(selectBoxList){
        for(var selectBoxId in selectBoxList){
            $(selectBoxList[selectBoxId]).find('option:gt(0)').remove();
            $(selectBoxList[selectBoxId]).prop('disabled', true);
            $(selectBoxList[selectBoxId]+' option:first-child').prop("selected", true);
        }
    };

    var displayErrorDiv = function(){
        $(".motoselector-error-div").show();
    };

    var addHandlers = function() {
       addManufacturerSelectorHandler();
       addCapacitySelectorHandler();
       addModelSelectorHandler();
    };

    var initDropdowns = function() {
        var manufacturerId = $("#motoManufacturer option:selected").val();
        if( manufacturerId !== null && manufacturerId !== "") {
            $('#motoManufacturer').trigger("change");
        }
    };

    var addManufacturerSelectorHandler = function(){
        $('#motoManufacturer').off().on('change',function() {
            var manufacturerId = $("#motoManufacturer").val();
            var previousManufacturer = $('input[name=previousManufacturer]').val();
            var previousCapacity = $('input[name=previousCapacity]').val();
            removeSelectBoxesContent(['#capacity','#model','#type']);
            $.ajax({
                type : 'GET',
                url : "/ws/moto/capacities/search?manufacturer=" + manufacturerId,
                success : function(data) {
                    if (data){
                        var triggerChange = false;
                        var capacitySelector = $("#capacity");
                        capacitySelector.prop('disabled',false).trigger("focus");
                        for ( var i in data.list) {
                            if (previousManufacturer === manufacturerId) {
                                if (previousCapacity != data.list[i]) {
                                    capacitySelector.append("<option value='" + data.list[i] + "'>" + data.list[i]+"</option>");
                                        $(".moto-search-label-model").hide();
                                        $(".moto-search-label-type").hide();
                                } else {
                                    capacitySelector.append(
                                        "<option selected value='" + data.list[i] + "'>" + data.list[i] + "</option>");
                                    triggerChange = true;
                                }
                            } else {
                                capacitySelector.append("<option value='" + data.list[i] + "'>" + data.list[i]+"</option>");
                                    $(".moto-search-label-model").hide();
                                    $(".moto-search-label-type").hide();
                                    $(".moto-search-label-brand").hide();
                                    $("#search-by-moto-results").hide();
                            }
                        }
                        if (triggerChange) {
                            capacitySelector.trigger("change");
                        }
                    }
                },
                error : function(xhr, ajaxOptions, thrownError) {
                   displayErrorDiv();
                }
            });
        });
    }

    var addCapacitySelectorHandler= function() {
        $('#capacity').off().on('change',function() {
            var manufacturerId = $("#motoManufacturer").val();
            var capacityID = $("#capacity option:selected").val();
            var previousModel = $('input[name=previousModel]').val();
            removeSelectBoxesContent(['#model','#type']);
            $.ajax({
                type : 'GET',
                url : "/ws/moto/models/search?manufacturer=" + manufacturerId + "&capacity=" + capacityID,
                success : function(data) {
                    if (data){
                        var triggerChange = false;
                        var modelSelector = $("#model");
                        modelSelector.prop('disabled', false).trigger("focus");
                        for (var i in data.list) {
                            if (previousModel != data.list[i].modelName) {
                                modelSelector.append(
                                    "<option value='" + data.list[i].modelName + "'>" + data.list[i].modelName + "</option>");
                            } else {
                                modelSelector.append(
                                    "<option selected value='" + data.list[i].modelName + "'>" + data.list[i].modelName + "</option>");
                                triggerChange = true;
                                $(".moto-search-label-model").show();
                            }
                        }
                        if (triggerChange) {
                            modelSelector.trigger("change");
                        }
                    }
                },
                error : function(xhr, ajaxOptions, thrownError) {
                    $(".motoselector-error-div").show();
                }
            });
        });
    };

    var addModelSelectorHandler= function() {
        $('#model').off().on('change',function() {
            var manufacturerId = $("#motoManufacturer").val();
            var capacityID = $("#capacity option:selected").val();
            var modelID = $("#model option:selected").val();
            var previousType = $('input[name=previousType]').val();
            removeSelectBoxesContent(['#type']);
            $.ajax({
                type : 'GET',
                url : "/ws/moto/types/search?manufacturer=" + manufacturerId + "&capacity=" + capacityID + "&model=" + modelID,
                success : function(data) {
                    if (data){
                        var typeSelector = $("#type");
                        for (var i in data.list) {
                            if (previousType != data.list[i]) {
                                typeSelector.append(
                                    "<option value='" + data.list[i] + "'>" + data.list[i] + "</option>");
                            } else {
                                typeSelector.append(
                                    "<option selected value='" + data.list[i] + "'>" + data.list[i] + "</option>");
                                    $(".moto-search-label-type").show();
                            }
                        }
                        typeSelector.prop('disabled', false).trigger("focus");
                        typeSelector.trigger("change");
                    }
                },
                error : function(xhr, ajaxOptions, thrownError) {
                    $(".motoselector-error-div").show();
                }
            });
        });
    };

    return {
        addHandlers: addHandlers,
        initDropdowns: initDropdowns
    }
}) (jQuery);

window.addEventListener('load', function() {
    var manufacturerSelector = $('#motoManufacturer');
    if (manufacturerSelector.length) {
        SearchByMoto.addHandlers();
        SearchByMoto.initDropdowns();
    }

    setTimeout(function () {
        $("#motoManufacturer").on('change', function(){
            var searchFormData = {};
            searchFormData["manufacturer"] = $('#motoManufacturer').val();
            searchFormData["isSearchByMoto"] = true;

            $.ajax({
                contentType : "application/json",
                type : "GET",
                url : "/search-moto",
                data : searchFormData,
                success: function(data) {
                    $("#search-by-moto-results").replaceWith($('#search-by-moto-results', $(data)));
                    $("#moto-search-label-brand").replaceWith($('#moto-search-label-brand', $(data)));
                    $("#breadcrumbs-container").replaceWith($('#breadcrumbs-container', $(data)));
                    $("#noProductsMessage").hide();
                    if ($("#capacity option:first:selected").length === 0) {
                        $(".moto-search-label-model").show();
                    } else {
                        $(".moto-search-label-model").hide();
                        $(".moto-search-label-type").hide();
                    }
                }
            });
        });

        $("#capacity").on('change', function(){
            var searchFormData = {};
            searchFormData["manufacturer"] = $('#motoManufacturer').val();
            searchFormData["capacity"] = $('#capacity').val();
            searchFormData["isSearchByMoto"] = true;

            $.ajax({
                contentType : "application/json",
                type : "GET",
                url : "/search-moto",
                data : searchFormData,
                success: function(data) {
                    $("#search-by-moto-results").replaceWith($('#search-by-moto-results', $(data)));
                    $("#noProductsMessage").hide();
                    if ($("#capacity option:first:selected").length === 0) {
                        $(".moto-search-label-model").show();
                        $(".moto-search-label-type").hide();
                        $(".moto-search-label-brand").hide();
                    }
                    else {
                        $(".moto-search-label-model").hide();
                        $(".moto-search-label-type").hide();
                        $(".moto-search-label-brand").hide();
                    }
                }
            });
        });

        $("#model").on('change', function(){
            var searchFormData = {};
            searchFormData["manufacturer"] = $('#motoManufacturer').val();
            searchFormData["capacity"] = $('#capacity').val();
            searchFormData["model"] = $('#model').val();
            searchFormData["isSearchByMoto"] = true;

            $.ajax({
                contentType : "application/json",
                type : "GET",
                url : "/search-moto",
                data : searchFormData,
                success: function(data) {
                    $("#search-by-moto-results").replaceWith($('#search-by-moto-results', $(data)));
                    $("#moto-search-label-brand").replaceWith($('#moto-search-label-brand', $(data)));

                    if ($("#model option:first:selected").length === 0) {
                        $(".moto-search-label-type").show();
                    } else {
                        $(".moto-search-label-type").hide();
                    }

                    if ($("#type option").length === 1) {
                        $(".moto-search-label-type").hide();
                    }

                    if ($("#type option").length === 1 && $('#moto-serp-results').text().trim() ==="") {
                        var noResaltText = $('#noProductsMessage').text().replace(/[0-9]+/g, '0');
                        $("#noProductsMessage").text(noResaltText);
                        $("#noProductsMessage").show();
                    } else {
                        $("#noProductsMessage").hide();
                    }
                    $("#type").trigger("change");
                }
            });
        });

        $("#type").on('change', function(){
            var searchFormData = {};
            searchFormData["manufacturer"] = $('#motoManufacturer').val();
            searchFormData["capacity"] = $('#capacity').val();
            searchFormData["model"] = $('#model').val();
            searchFormData["type"] = $('#type').val();
            searchFormData["isSearchByMoto"] = true;

            $.ajax({
                contentType : "application/json",
                type : "GET",
                url : "/search-moto",
                data : searchFormData,
                success: function(data) {
                    $("#search-by-moto-results").replaceWith($('#search-by-moto-results', $(data)));
                    $("#moto-search-label-brand").replaceWith($('#moto-search-label-brand', $(data)));
                    if (($("#type option").length === 1 || $("#type option:first:selected").length === 0) &&
                            $('#moto-serp-results').text().trim() === "") {
                        var noResaltText = $('#noProductsMessage').text().replace(/[0-9]+/g, '0');
                        $("#noProductsMessage").text(noResaltText);
                        $("#noProductsMessage").show();
                    } else {
                        $("#noProductsMessage").hide();
                    }
                    if ($("#type option").length > 1) {
                        $(".moto-search-label-type").show();
                    }
                    $("#brand").trigger("change");
                }
            });
        });

        $(document).on('change',"#brand", function(){
            var searchFormData = {};
            searchFormData["manufacturer"] = $('#motoManufacturer').val();
            searchFormData["capacity"] = $('#capacity').val();
            searchFormData["model"] = $('#model').val();
            searchFormData["type"] = $('#type').val();
            searchFormData["brand"] = $('#brand').val();
            searchFormData["isSearchByMoto"] = true;

            $.ajax({
                contentType : "application/json",
                type : "GET",
                url : "/search-moto",
                data : searchFormData,
                success: function(data) {
                    $("#search-by-moto-results").replaceWith($('#search-by-moto-results', $(data)));
                    if ($("#type option").length > 1) {
                        $(".moto-search-label-type").show();
                    }
                    if ($("#moto-search-label-brand option").length >= 1) {
                        $("moto-search-label-brand").show();
                    }
                }
            });
        });
    }, 300)

});